module.exports = __webpack_public_path__ + "img/iconSend.2f19c3fe.svg";